"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BulkCreateCompetenciesRequest () {
        return BulkCreateCompetenciesRequest;
    },
    get CheckNameQuery () {
        return CheckNameQuery;
    },
    get CompetencySortBySchema () {
        return CompetencySortBySchema;
    },
    get CreateCompetencyBody () {
        return CreateCompetencyBody;
    },
    get ListCompetenciesQuery () {
        return ListCompetenciesQuery;
    },
    get UpdateCompetencyBody () {
        return UpdateCompetencyBody;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const CompetencySortBySchema = _zod.z.enum([
    "name",
    "status",
    "levels_count"
]);
const ListCompetenciesQuery = _zod.z.object({
    name: _zod.z.string().optional(),
    status: _zod.z.enum([
        "active",
        "archived",
        "any"
    ]).default("active"),
    companyWide: _zod.z.enum([
        "true",
        "false"
    ]).transform((v)=>v === "true").optional(),
    sortBy: CompetencySortBySchema.default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
// Trim BEFORE validating min(1) — z.string().min(1).trim() leaves whitespace-only strings as
// valid (length 3 passes min(1), then trim collapses to ""). Pipe ensures min/max see the
// trimmed value.
const TrimmedCompetencyName = _zod.z.string().trim().pipe(_zod.z.string().min(1).max(_models.MAX_COMPETENCY_NAME_LENGTH));
const CheckNameQuery = _zod.z.object({
    name: TrimmedCompetencyName,
    excludeId: _utilsisomorphic.transformObjectId.optional()
});
const CreateCompetencyBody = _zod.z.object({
    name: TrimmedCompetencyName,
    description: _zod.z.string().max(1000).default(""),
    is_company_wide: _zod.z.boolean().default(false),
    levels: _zod.z.array(_zod.z.object({
        rank: _zod.z.number().int().min(1).max(5),
        name: _zod.z.string().min(1),
        description: _zod.z.string().max(1000).default("")
    })).max(5).default([])
});
const UpdateCompetencyBody = _zod.z.object({
    name: TrimmedCompetencyName.optional(),
    description: _zod.z.string().max(1000).optional(),
    is_company_wide: _zod.z.boolean().optional(),
    levels: _zod.z.array(_zod.z.object({
        rank: _zod.z.number().int().min(1).max(5),
        name: _zod.z.string().min(1),
        description: _zod.z.string().max(1000).default("")
    })).max(5).optional()
});
const BulkLevelInput = _zod.z.object({
    rank: _zod.z.number().int().min(1).max(5),
    name: _zod.z.string().min(1),
    description: _zod.z.string().max(1000).default("")
});
const BulkCompetencyInput = _zod.z.object({
    name: _zod.z.string().min(1).trim(),
    description: _zod.z.string().max(1000).default(""),
    levels: _zod.z.array(BulkLevelInput).min(1).max(5)
});
const BulkCreateCompetenciesRequest = _zod.z.object({
    competencies: _zod.z.array(BulkCompetencyInput).min(1).max(_models.MAX_COMPETENCY_FRAMEWORK_SIZE)
});
